import $ from "jquery";
import CookieConsent from "@alpaga/cookie-consent";
import "./../styles/main.scss";
import Siema from "siema";
import AOS from "aos";
import Rellax from "rellax";
require('./woocommerce/Global');
var Plyr = require("plyr");
require("./helpers/pagination");
import Cookie from "js-cookie";
// require("./helpers/ihavecookies");
require("jquery.scrollto");
require("./isotopepagination");
import Glightbox from "glightbox";
function paginateItems(iso) {
    if ($("#list-elements").data('paginate'))
        $("#list-elements").data('paginate').kill();
    setTimeout(function () {
        $("#list-elements").paginate({ 'perPage': 10, 'scope': $('.item'), onPageClick: function () {
                setTimeout(function () { iso.arrange(); $.scrollTo("#filters", 500); }, 100);
            } });
        iso.arrange();
    }, 300);
}
$(document).ready(function () {
    var iso = null;
    var consentBox = Glightbox({
        width: "auto",
        closeOnOutsideClick: false,
        elements: [
            {
                'content': document.getElementById('pop-up-form')
            },
        ]
    });
    if (!Cookie.get("closepopup")) {
        setTimeout(function () {
            $('#header-pop-up').fadeIn(250);
        }, 250);
    }
    $('#header-pop-up').on("click", ".close a", function (e) {
        e.preventDefault();
        $('#header-pop-up').fadeOut(260);
        Cookie.set("closepopup", "yes");
    });
    var eq = Cookie.get("equinoxconsent");
    var intervalGL;
    var currentUrl = null;
    $("body").on("click", "a.consent", function (e) {
        // let consentBoxC = Glightbox({
        //     closeOnOutsideClick: false,
        //     elements: [
        //         {
        //             'href' : $(e.currentTarget).attr("href"),
        //             'type' : 'external'
        //         },
        //     ],
        // });
        $("#pop-up-form").find("#nf-field-50").val($(e.currentTarget).attr("href"));
        e.preventDefault();
        if (eq === void 0) {
            consentBox.open();
            intervalGL = setInterval(function () {
                if ($('#success-nf-form').length) {
                    console.log("Sent");
                    Cookie.set("equinoxconsent", "1");
                    eq = "yes";
                    clearInterval(intervalGL);
                    window.open($(e.currentTarget).attr("href"), "_blank");
                }
            }, 500);
        }
        else {
            window.open($(e.currentTarget).attr("href"), "_blank");
        }
    });
    if ($("#list-elements").length) {
        var firstTime = true;
        var grid = document.querySelector('#list-elements');
        // filter with selects and checkboxes
        var $selects = $('#filters select');
        var $checkboxes = $('#filters input');
        // iso = new Isotope(grid, {
        //     itemSelector: '.item'
        // });
        // iso.layout();
        // // paginateItems(iso);
        // $checkboxes.on("click", function(e) {
        //     let current = false;
        //     if ($(e.currentTarget).hasClass("current")) {
        //         current = false;
        //         $(e.currentTarget).removeClass("current");
        //     } else {
        //         current = e.currentTarget.checked;
        //         $(e.currentTarget).addClass("current");
        //     }
        //     $(e.currentTarget).parent().parent().find("input:checked").prop("checked", false);
        //     $(e.currentTarget).prop("checked", current);
        //     // map input values to an array
        //     var exclusives = [];
        //     var inclusives = [];
        //     // exclusive filters from selects
        //     $selects.each( function( i, elem ) {
        //         if ( elem.value ) {
        //             exclusives.push( elem.value );
        //         }
        //     });
        //     // inclusive filters from checkboxes
        //     $checkboxes.each( function( i, elem ) {
        //         // if checkbox, use value if checked
        //         if ( elem.checked ) {
        //             inclusives.push( elem.value );
        //         }
        //     });
        //     // first combine exclusives
        //     exclusives = exclusives.join('');
        //     var filterValue;
        //     if ( inclusives.length ) {
        //         // map inclusives with exclusives for
        //         filterValue = $.map( inclusives, function( value ) {
        //             return value + exclusives;
        //         });
        //         filterValue = filterValue.join('');
        //     } else {
        //         filterValue = exclusives;
        //     }
        //     iso.arrange({
        //         filter: filterValue
        //     });
        // });
        $('#properties .header .buttons').on("click", "a", function (e) {
            e.preventDefault();
            $('#properties .header .buttons a').addClass("outline");
            $(e.currentTarget).removeClass("outline");
            $(".iframe").hide();
            $($(e.currentTarget).attr("href")).fadeIn(350);
        });
        $('#properties iframe').on("click", function (e) {
            // alert("Hello");
        });
        // if ($('#filters input:checked').length) {
        //     let nb = $('#filters input:checked').length;
        //     let f = [];
        //     $('#filters input:checked').each((k, v) => {
        //         f += $(v).val();
        //         if (k + 1 == nb) {
        //             setTimeout(() => {
        //                 iso.arrange({
        //                     filter: f
        //                 });
        //             }, 500);
        //         }
        //     });
        // } else {
        //     setTimeout(() => {
        //         iso.arrange();
        //     }, 500);
        // }
    }
    var gl = Glightbox({});
    AOS.init({
        disable: 'mobile'
    });
    $('.player').each(function (k, e) {
        var player = new Plyr(e);
    });
    var rellax = null;
    if ($('.rellax').length && $(window).width() > 768) {
        rellax = new Rellax('.rellax', {
            // speed: -2,
            center: true
            // center: false
        });
    }
    setTimeout(function () { AOS.refresh(); }, 500);
    $.extend($.scrollTo.defaults, {
        axis: 'y'
    });
    var CookieConsentNode = new CookieConsent({
        locale: "fr",
        content: {
            link: "https://emaprod.com/fr/cookies-policy/",
            banner: {
                title: "En utilisant ce site, vous acceptez l'utilisation des cookies."
            },
            popup: {
                title: "Ce site utilise des cookies.",
                description: "Ce site utilise des cookies. Nous utilisons des cookies pour que notre site web fonctionne au mieux, améliorant ainsi votre expérience en ligne. Afin d’en savoir plus sur l’utilisation des cookies, les plug-ins pour les réseaux sociaux ainsi que le web tracking, n’hésitez pas à consulter notre page d’informations sur les Cookies ainsi que notre Déclaration de Protection des Données."
            }
        },
        cookies: {
            'necessary': {
                name: "necessary",
                disabled: true,
                value: true,
                title: "Cookies nécessaires",
                description: "Les cookies nécessaires aident à rendre un site Web utilisable en activant de base \
                des fonctions telles que la navigation sur les pages et l'accès aux zones sécurisées du site Web. Le site Web ne peut pas \
                fonctionner correctement sans ces cookies.",
                "function": function () { },
                cookies: [
                    {
                        name: "CookieConsent",
                        provider: "cookieconsent.extension",
                        purpose: "Stocke l'état de consentement des cookies de l'utilisateur pour le domaine actuel",
                        expiry: "1 an",
                        type: "HTTP"
                    },
                ]
            },
            analytics: {
                name: "analytics",
                value: true,
                title: "Analytics Cookies",
                "function": function () {
                    analyticsFn();
                },
                description: "Les cookies analytiques aident les propriétaires de sites Web à comprendre comment les visiteurs \
                interagir avec les sites Web en collectant et en signalant des informations de manière anonyme.",
                cookies: [
                    {
                        name: "_ga",
                        provider: "Google",
                        purpose: "Enregistre un identifiant unique utilisé pour générer des données statistiques sur la façon dont le visiteur utilise le site Web.",
                        expiry: "2 ans",
                        type: "HTTP"
                    },
                    {
                        name: "_gat",
                        provider: "Google",
                        purpose: "Utilisé par Google Analytics pour réduire le taux de demandes",
                        expiry: "1 jour",
                        type: "HTTP"
                    },
                    {
                        name: "_gid",
                        provider: "Google",
                        purpose: "Enregistre un identifiant unique utilisé pour générer des données statistiques sur la façon dont le visiteur utilise le site Web.",
                        expiry: "1 jour",
                        type: "HTTP"
                    }
                ]
            },
            some: {
                name: "some",
                value: true,
                title: "Cookies 'Marketing'",
                "function": function () {
                    someFn();
                },
                description: "Ces cookies sont activés par les services proposés sur les réseaux sociaux que nous avons ajoutés au site Web afin de vous donner la possibilité de partager notre contenu avec votre réseau et vos connaissances. Ils nous permettent également de suivre votre navigation sur d’autres sites Web et d’établir un profil de vos intérêts. Cela peut avoir un impact sur le contenu et les messages affichés sur les autres sites Web que vous consultez. Si vous n'autorisez pas ces cookies, il se peut que vous ne puissiez pas utiliser ou visualiser ces outils de partage.",
                cookies: [
                    {
                        name: "_fbp",
                        provider: "Facebook",
                        purpose: " Utilisé par Facebook pour fournir une série de produits publicitaires, tels que des offres en temps réel d'annonceurs externes",
                        expiry: "1 jour",
                        type: "HTTP"
                    },
                    {
                        name: "Fr",
                        provider: "Facebook",
                        purpose: "Utilisé par Facebook pour fournir une série de produits publicitaires, tels que des offres en temps réel de tiers",
                        expiry: "3 mois",
                        type: "HTTP"
                    }
                ]
            }
        }
    });
    CookieConsentNode.init();
    if ($(".view-cookie-banner").length) {
        $(".view-cookie-banner").on("click", function (e) {
            e.preventDefault();
            CookieConsentNode.showDetails();
        });
    }
    $("body").on("click", "a[href^='#']", function (e) {
        e.preventDefault();
        var node = $(e.currentTarget).attr("href");
        if (node == "#iframe-1" || node == "#iframe-2" || node.includes("paginate")) { }
        else {
            if ($(node).length) {
                var posY = $(node).offset().top - $("#main-header").height();
                if (posY >= 0) {
                    $.scrollTo(posY, 400);
                    $("#nav-main").removeClass("show-menu");
                    $("#menu-switcher a").removeClass("show-menu");
                }
            }
        }
    });
    $('body').on("click", ".shared-item", function (e) {
        e.preventDefault();
        window.open($(e.currentTarget).attr("href"), "", "width=500,height=350");
    });
    $("body").on("click", "#menu-switcher a", function (e) {
        e.preventDefault();
        $("#nav-main").toggleClass("show-menu");
        $(e.currentTarget).toggleClass("show-menu");
    });
    $("body").on("click", ".goTo, .menu-item.Button a", function (e) {
        var elm = $(e.currentTarget).attr("href");
        var posY = $(elm).offset().top - $("#main-header").height();
        $.scrollTo(posY, 400);
    });
    $('.sliderWrapper').each(function (k, v) {
        var siema = $(v).find(".siema").get(0);
        var interval;
        var navigation = $(v).find(".navigation");
        var slider = new Siema({
            selector: siema,
            duration: 300,
            easing: 'ease-out',
            perPage: 1,
            startIndex: 0,
            draggable: true,
            multipleDrag: false,
            threshold: 20,
            loop: true,
            rtl: false,
            onInit: function () {
                navigation.find("span:eq(0)").addClass("current");
            },
            onChange: function () {
                clearInterval(interval);
                interval = setInterval(function () { return slider.next(); }, 5000);
                navigation.find(".current").removeClass("current");
                navigation.find("span:eq(" + slider.currentSlide + ")").addClass("current");
            }
        });
        interval = setInterval(function () { return slider.next(); }, 5000);
        navigation.on("click", "span", function (e) {
            e.preventDefault();
            slider.goTo($(e.currentTarget).index());
        });
    });
    // const list:any = new Siema({
    //     selector: '#properties .list',
    //     draggable: false,
    //     duration: 0,
    //     onInit: function() {
    //         $('#properties .filters ul').children(":first").addClass("active");
    //     },
    //     onChange: function() {
    //         let navigation = $('#properties .filters ul');
    //         navigation.find(".active").removeClass("active");
    //         navigation.children(":nth-child("+(this.currentSlide+1)+")").addClass("active");
    //     }
    // });
    // $("#properties").on("click", ".list .control a", (e:Event) => {
    //     const elm = $(e.currentTarget);
    //     if (elm.parent().hasClass("left")) {
    //         list.prev();
    //     } else {
    //         list.next();
    //     }
    // });
    // $('#properties .filters').on("click", "a", (e:Event) => {
    //     e.preventDefault();
    //     let $this = $(e.currentTarget);
    //     let parentIndex = $this.parent().index();
    //     list.goTo(parentIndex);
    // });
});
